Vue.component("set-as-default-form", require("./../VueComponents/manufaktur/amag/SetAsDefaultForm").default);
Vue.component("add-payment-method-amag", require("./../VueComponents/manufaktur/amag/AddPaymentMethod").default);
Vue.component("add-credit-card", require("./../VueComponents/manufaktur/amag/AddCreditCard").default);
